import { render } from "./CxPointCodesFilter.vue?vue&type=template&id=348f11c0"
import script from "./CxPointCodesFilter.vue?vue&type=script&lang=js"
export * from "./CxPointCodesFilter.vue?vue&type=script&lang=js"

import exportComponent from "/home/ec2-user/workspace/_ui2_staging_ui2-staging-0.124.0/apps/ui2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__